import * as t from "io-ts";

export const VerificationStatus = t.union([
  t.literal("not_started"),
  t.literal("verification_passed"),
  t.literal("verification_failed"),
  t.literal("verification_skipped"),
  t.literal("verification_error"),
]);

export type VerificationStatus =
  | "not_started"
  | "verification_passed"
  | "verification_failed"
  | "verification_skipped"
  | "verification_error";
